import { ChartEvent, IBarrier } from '../../types'

export interface IAddBarrierEditorReducer {
    targetUid: string
}

export interface ISetAddBarrierTargetAction {
    type: 'SET_ADD_BARRIER_TARGET'
    payload: {
        newTargetUid: string
    }
}

export interface IClearAddBarrierTargetAction {
    type: 'CLEAR_ADD_BARRIER_TARGET'
}

export type IAddBarrierEditorActions = ISetAddBarrierTargetAction | IClearAddBarrierTargetAction

const initialState: IAddBarrierEditorReducer = {
    targetUid: null
}

export function addBarrierEditorReducer(
    state = initialState,
    action: IAddBarrierEditorActions
): IAddBarrierEditorReducer {
    switch (action.type) {
        case 'SET_ADD_BARRIER_TARGET':
            return {
                targetUid: action.payload.newTargetUid
            }

        case 'CLEAR_ADD_BARRIER_TARGET':
            return {
                targetUid: null
            }

        default:
            return state
    }
}
